import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MvsCrudService} from '../../../../core/shared/service/crud/mvs-crud.service';

/**
 * Service for ExternalSyncMemberStatus entity CRUD operations.
 * F-030: Integration with External Marketing Tools
 */
@Injectable({
    providedIn: 'root'
})
export class ExternalSyncMemberStatusService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/externalSyncMemberStatuses');
    }

    getObjectIcon(): string {
        return 'fa-solid fa-user-check';
    }
}
